if (!customElements.get('image-cards-peek-slider')) {
  class ImageCardsPeekSlider extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.splide = null;
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.init();
    }

    init() {
      if (typeof window.Splide !== 'undefined') {
        this.mountSlider();
        return;
      }

      const checkInterval = window.setInterval(() => {
        if (typeof window.Splide !== 'undefined') {
          window.clearInterval(checkInterval);
          this.mountSlider();
        }
      }, 100);

      window.setTimeout(() => {
        window.clearInterval(checkInterval);
      }, 10000);
    }

    mountSlider() {
      const slider = this.querySelector('[data-image-cards-peek-slider]');
      if (!slider || slider.dataset.sliderMounted === 'true') return;

      const totalSlides = slider.querySelectorAll('.splide__slide').length;
      if (!totalSlides) return;

      const showControls = totalSlides > 1;

      slider.dataset.sliderMounted = 'true';

      const splide = new Splide(slider, {
        type: showControls ? 'loop' : 'slide',
        arrows: showControls,
        pagination: showControls,
        drag: showControls,
        rewind: false,
        speed: 500,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        gap: '24px',
        perMove: 1,
        flickMaxPages: 1,
        updateOnMove: true,
        perPage: 1,
        padding: {
          left: '0px',
          right: showControls ? '30%' : '0px',
        },
        classes: {
          arrows: 'splide__arrows image-cards-peek-slider__arrows',
          arrow: 'splide__arrow image-cards-peek-slider__arrow',
          prev: 'splide__arrow--prev image-cards-peek-slider__arrow image-cards-peek-slider__arrow--prev',
          next: 'splide__arrow--next image-cards-peek-slider__arrow image-cards-peek-slider__arrow--next',
          pagination: 'splide__pagination image-cards-peek-slider__pagination',
          page: 'splide__pagination__page image-cards-peek-slider__pagination-dot',
        },
        breakpoints: {
          767: {
            gap: '16px',
            perPage: 1,
            padding: {
              left: '0px',
              right: showControls ? '8%' : '0px',
            },
          },
        },
      });

      if (showControls) {
        splide.on('arrows:mounted', (prev, next) => {
          const arrowIcon = `
            <span class="image-cards-peek-slider__arrow-icon" aria-hidden="true">
              <svg viewBox="0 0 27 17" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.667 9.81849L26.6672 7.15196H5.10467L10.3709 1.88561L8.48534 0L0 8.48529L8.48534 16.9706L10.3709 15.0849L5.10453 9.81863L26.667 9.81849Z" />
              </svg>
            </span>
          `;

          if (prev) {
            prev.innerHTML = arrowIcon;
            prev.setAttribute('aria-label', 'Previous slide');
          }

          if (next) {
            next.innerHTML = arrowIcon;
            next.setAttribute('aria-label', 'Next slide');
          }
        });

        splide.on('pagination:mounted', (data) => {
          data.items.forEach((item, index) => {
            item.button.innerHTML = `
              <span class="image-cards-peek-slider__pagination-icon" aria-hidden="true">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5 0L15.5 7.5L23 11.5L15.5 15.5L11.5 23L7.5 15.5L0 11.5L7.5 7.5L11.5 0Z" fill="white"/>
                </svg>
              </span>
            `;
            item.button.setAttribute('aria-label', `Go to slide ${index + 1}`);
          });
        });
      }

      splide.mount();
      this.splide = splide;
    }
  }

  customElements.define('image-cards-peek-slider', ImageCardsPeekSlider);
}
